import { ContractConst } from '@blcloud/bl-datamodel/const/contract';
import { SnsDiv } from '@blcloud/bl-datamodel/enum/sns/sns-div';

/** SNS区分と定義の対応マップ */
export const SnsDefinitionMap = {
  [SnsDiv.LINE]: {
    serviceId: ContractConst.SERVICEID_OPT_CMN_LINE_BASE,
    followerCalled: '友だち'
  }
};

/** フォロワーデフォルト呼称 */
export const SnsFollowerCalledDefault = 'フォロワー';



// WEBPACK FOOTER //
// ./src/app/core/const/sns-define.ts